import { createSlice } from "@reduxjs/toolkit";

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState: {
    isLoading: false,
    topFivePujaList: [],
    topFiveChadhavaTempleList: [],
    topFiveRatingsList: [],
    pujaVideos: [],
    chadhavaVideos: [],
  },
  reducers: {
    setLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setTopFivePujaList: (state, action) => {
      state.topFivePujaList = action.payload;
    },
    setTopFiveChadhavaTempleList: (state, action) => {
      state.topFiveChadhavaTempleList = action.payload;
    },
    setTopFiveRatingsList: (state, action) => {
      state.topFiveRatingsList = action.payload;
    },
    setPujaVideos: (state, action)=>{
      state.pujaVideos = action.payload;
    },
    setChadhavaVideos: (state,action)=>{
      state.chadhavaVideos = action.payload;
    }

  },
});

export const {
  setLoading,
  setTopFivePujaList,
  setTopFiveChadhavaTempleList,
  setTopFiveRatingsList,
  setPujaVideos,
  setChadhavaVideos,
} = dashboardSlice.actions;

export default dashboardSlice.reducer;
